import {useEffect} from "react"

import {OutstandingBalance} from "./OutstandingBalance"
import {LowOutstandingBalance} from "./LowOutstandingBalance"
import {PaymentBeingProcessing} from "./PaymentBeingProcessed"
import {SettledAllAccounts} from "./SettledAllAccounts"
import {InPaymentPlan} from "./InPaymentPlan"
import {InPaymentArrangement} from "./InPaymentArrangement"
import {Dispute} from "./Dispute"
import {PaymentsDisabled} from "./PaymentsDisabled"
import {Recalled} from "./Recalled"
import {CaseEscalated} from "./CaseEscalated"
import {NotificationOfAssignment} from "./NotificationOfAssignment"
import {ScrubDetected} from "./ScrubDetected"
import {AccountsClosedDueToSOL} from "./AccountsClosedDueToSOL"
import {PendingScrub} from "./PendingScrub"

import {useAnalytics} from "@indebted/analytics"
import {ErrorPage} from "@indebted/components/Error"
import {CustomerFindResponse} from "@indebted/api/customer/customerFind"

function CustomerStatuses({result, secureCode}: {result: CustomerFindResponse; secureCode: string}) {
	const {track} = useAnalytics()

	useEffect(() => {
		track("LandingPageViewed", {
			SecureCode: secureCode,
			CustomerStatus: result.Status,
		})
	}, [result.Status, track, secureCode])

	switch (result.Status) {
		case "OutstandingBalance":
			return <OutstandingBalance {...result.Payload} />
		case "LowOutstandingBalance":
			return <LowOutstandingBalance {...result.Payload} />
		case "PaymentBeingProcessed":
			return <PaymentBeingProcessing {...result.Payload} />
		case "SettledAllAccounts":
			return <SettledAllAccounts {...result.Payload} />
		case "InPaymentPlan":
			return <InPaymentPlan {...result.Payload} />
		case "InPaymentArrangement":
			return <InPaymentArrangement {...result.Payload} />
		case "Dispute":
			return <Dispute {...result.Payload} />
		case "PaymentsDisabled":
			return <PaymentsDisabled {...result.Payload} />
		case "Recalled":
			return <Recalled {...result.Payload} />
		case "CaseEscalated":
			return <CaseEscalated {...result.Payload} />
		case "NotificationOfAssignment":
			return <NotificationOfAssignment {...result.Payload} />
		case "ScrubDetected":
			// ScrubDetected has no Payload
			return <ScrubDetected />
		case "AccountsClosedDueToSOL":
			return <AccountsClosedDueToSOL {...result.Payload} />
		case "PendingScrub":
			// PendingScrub has no Payload
			return <PendingScrub />
		default:
			return <ErrorPage message="Unknown customer status" />
	}
}

export {CustomerStatuses}
